import React from "react";
import Modal from "../../../../elements/Modal";
import ManageFaq from "../ManageFaq";

const ManageFaqModal = ({
  open,
  close = () => {},
  getResponse = () => {},
  data = {},
}) => {
  return (
    <Modal isOpen={open} setIsOpen={close} size="xl2" title={"Create New "}>
      <ManageFaq getResponse={getResponse} close={close} data={data} />
    </Modal>
  );
};

export default ManageFaqModal;
